import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { showErrorToast, showSuccessToast } from 'components/Toast';
import BaseInput from 'components/Inputs/BaseInput';
import SolidButton from 'components/SolidButton';

import { REQUIRED_RULE } from 'utils/constants';
import GeneralApi from 'utils/generalApi';
import { useAuth } from 'contexts/Auth';

export default function OperatorModalContent({
  title,
  onClose,
  onSuccess,
}: {
  title: string;
  onClose: () => void;
  onSuccess: () => void;
}) {
  const {
    register,
    watch,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      level: '20',
    },
  });
  const history = useNavigate();
  const auth = useAuth();

  const generalApi = useMemo(() => new GeneralApi(auth, history), [auth, history]);

  const [loading, setLoading] = useState(false);

  const submitAction = async (data: any) => {
    setLoading(true);
    let result: any = await generalApi.post('/add_operators', data);
    setLoading(false);
    if (!result.success) return showErrorToast(result.data.err);
    showSuccessToast('Operador creado');
    onSuccess();
  };

  const buildBaseInput = (
    label: string,
    type: React.HTMLInputTypeAttribute,
    name: string,
    rules: any,
    props: any
  ) => {
    return (
      <BaseInput
        label={label}
        type={type}
        name={name}
        register={register}
        control={control}
        watch={watch}
        errors={errors}
        rules={rules}
        {...props}
      />
    );
  };

  return (
    <form onSubmit={handleSubmit(submitAction)}>
      <div className="bg-primary-600 rounded-t-lg px-4 pb-4 sm:flex sm:items-start sm:p-6 sm:py-4">
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <h3 className="text-lg font-medium leading-6 text-white" id="modal-headline">
            {title || 'Confirmar acción'}
          </h3>
        </div>
      </div>
      <div className="space-y-4 px-4 py-5 sm:p-6">
        {buildBaseInput('Nombres', 'text', 'name', REQUIRED_RULE, {})}
        {buildBaseInput('Apellido Paterno', 'text', 'lname_p', REQUIRED_RULE, {})}
        {buildBaseInput('Apellido Materno', 'text', 'lname_m', REQUIRED_RULE, {})}
        {buildBaseInput('Correo', 'email', 'email', REQUIRED_RULE, {})}
        {buildBaseInput('Celular', 'text', 'cellphone', REQUIRED_RULE, {})}
        {buildBaseInput('Tipo', 'select', 'level', REQUIRED_RULE, {
          options: [
            { value: '20', name: 'Front Office' },
            { value: '21', name: 'Back Office' },
            { value: '22', name: 'Contador' },
            { value: '11', name: 'SEO' },
          ],
        })}
        {buildBaseInput('Contraseña', 'password', 'password', REQUIRED_RULE, {})}
      </div>
      <div className="bg-gray-50 rounded-b-lg px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <SolidButton
          className="w-auto sm:ml-3"
          isLoading={loading}
          onClick={() => handleSubmit(submitAction)}
        >
          Crear
        </SolidButton>
        <button
          type="button"
          onClick={onClose}
          className="focus:ring-primary-500 mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
        >
          Cancelar
        </button>
      </div>
    </form>
  );
}
